import { Component } from '@angular/core';

@Component({
  selector: 'app-security-zone-reports',
  templateUrl: './security-zone-reports.component.html',
  styleUrls: ['./security-zone-reports.component.scss']
})
export class SecurityZoneReportsComponent {

}
